var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.model.Items.length == 3
    ? _c("div", { staticClass: "categories__row" }, [
        _c("div", { staticClass: "categories__col" }, [
          _c(
            "a",
            {
              staticClass: "categories__map",
              attrs: {
                href: _vm.bigItem.Link.Url,
                target: _vm.bigItem.Link.Target,
              },
            },
            [
              _c("img", {
                attrs: {
                  "data-src": _vm.bigItem.Image,
                  alt: _vm.bigItem.ImageAlt,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "categories__place" }, [
                _vm._v(_vm._s(_vm.model.CopyTitle)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "categories__text",
            domProps: { innerHTML: _vm._s(_vm.model.Copy) },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "categories__col" }, [
          _c(
            "ul",
            { staticClass: "categories__group" },
            _vm._l(_vm.smallItems, function (i) {
              return _c("li", [
                i.Link != null
                  ? _c(
                      "a",
                      { attrs: { href: i.Link.Url, target: i.Link.Target } },
                      [
                        _c("img", {
                          attrs: { "data-src": i.Image, alt: i.ImageAlt },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "categories__title" }, [
                          _vm._v(_vm._s(i.Link.Name)),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }